import { useTranslation } from '@aimsos/i18n';
import { useEventDraft } from '../../../../context/useEventDraft.js';
import ClaimRow from './ClaimRow.jsx';

/**
 * Claims with per-claim Approve / Reject / Correct. Decisions live in
 * EventDraftProvider because the DECISION bar sits in the pinned footer.
 *
 * @param {string} titleKey — i18n key that receives `{ count }` (e.g. claimsExtracted)
 */
function ClaimsList({ event, titleKey = 'claims.extracted' }) {
  const { t } = useTranslation('work-queues-app');
  const { itemDecisions, setItemDecision } = useEventDraft();
  const claims = event.detail?.claims ?? [];

  if (!claims.length) return null;

  return (
    <div>
      <p className="text-xs font-semibold uppercase tracking-wide text-content-faint">
        {t(titleKey, { count: claims.length })}
      </p>

      <div className="mt-3 flex flex-col gap-3">
        {claims.map((claim) => (
          <ClaimRow
            key={claim.id}
            claim={claim}
            decision={itemDecisions[claim.id]}
            onDecide={setItemDecision}
          />
        ))}
      </div>
    </div>
  );
}

export default ClaimsList;
